// Shared utility functions among the target tables
import React from 'react';

export const getDisplayValue = function(value, roundTo = 2) {
  if (!value) {
    return <span className="pay-elements-table__no-data">No data</span>;
  }

  if (value === 'Not Purchased') {
    return <span className="pay-elements-table__no-data">Not Purchased</span>;
  }

  if (roundTo >= 0) {
    return Number(value).toLocaleString('en', {
      minimumFractionDigits: roundTo,
      maximumFractionDigits: roundTo
    });
  }

  const pow = Math.pow(10, roundTo * -1);
  const display = Math.round(value / pow) * pow;
  return Number(display).toLocaleString('en', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
};

export const calcYoYChange = function(prev, cur, roundTo = 2) {
  const diff = ((cur - prev) / prev) * 100;
  return diff.toFixed(roundTo);
};

export const getYoYChange = function(prev, cur, roundTo) {
  if (prev === null || cur === null) return '-';
  if (prev === 'Not Purchased' || cur === 'Not Purchased') return '-';

  let yoyChange;
  let iconClassname;
  let textClassname;
  const diff = calcYoYChange(prev, cur, roundTo);

  if (diff >= 0) {
    yoyChange = `+${diff}%`;
    iconClassname = 'icon-up';
    textClassname = 'pay-elements-table__positive';
  } else {
    yoyChange = `${diff}%`;
    iconClassname = 'icon-down';
    textClassname = 'pay-elements-table__negative';
  }

  return (
    <span className={textClassname}>
      {yoyChange}
      <i className={iconClassname} />
    </span>
  );
};
